import Css from "./style.module.scss";

import { getActiveOrganization } from "selectors/organizations";
import { getPricesData } from "selectors/metaData";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import Button from "nlib/ui/Button";
import Constants from "const/Constants";
import Money from "utils/Money";
import React, { useMemo } from "react";
import Texts from "utils/Texts";

const UpsellCard = ({ onClick }) => {
  const { uiTexts, messages } = useSelector(getTextsData);

  const activeOrganization = useSelector(getActiveOrganization);

  const { oneTimePrices: { roboticUpsell: roboticUpsellPrices = {} } = {} } = useSelector(getPricesData);

  const upsellPrice = useMemo(() => {
    const organizationCurrency = activeOrganization?.currency || Constants.DEFAULT_CURRENCY;

    const price = roboticUpsellPrices[organizationCurrency] || roboticUpsellPrices[Constants.DEFAULT_CURRENCY];

    return price
      ? Money.toMoneyString(
        price,
        roboticUpsellPrices[organizationCurrency] ? organizationCurrency : Constants.DEFAULT_CURRENCY
      )
      : Constants.EMPTY_PLACEHOLDER;
  }, [
    activeOrganization,
    roboticUpsellPrices
  ]);

  return (
    <div className={Css.upsellCard}>
      <div className={Css.title}>{uiTexts.catchUpBookkeeping}</div>
      <div className={Css.description}>
        {Texts.replaceVars(messages.upsellSettingsCardDescription, {
          price: upsellPrice
        })}
      </div>
      <div className={Css.actions}>
        <Button primary onClick={onClick}>
          {uiTexts.unlockEarlierPeriods}
        </Button>
      </div>
    </div>
  );
};

export default UpsellCard;
